// In EnglishTool/pool/speakerMoodPool.js
export const speakerMoodPoolsByPlay = {
  "A Midsummer Night’s Dream": [
    {
      excerpt: "Lord, what fools these mortals be!",
      speaker: "Puck",
      mood: "Amused",
      speakerDistractors: ["Oberon", "Hermia", "Titania"],
      moodDistractors: ["Angry", "Confused", "Hopeful"]
    }
    // Add more real passages/characters from the play as needed
  ],
  "Macbeth": [
    {
      excerpt: "Out, out, brief candle! Life's but a walking shadow.",
      speaker: "Macbeth",
      mood: "Hopeless",
      speakerDistractors: ["Lady Macbeth", "The narrator", "A servant"],
      moodDistractors: ["Joyful", "Fearful", "Excited"]
    }
    // ...add more as needed
  ],
  // Add more plays
  "Poetry": [
    {
      excerpt: "I wandered lonely as a cloud that floats on high o'er vales and hills.",
      speaker: "The poet",
      mood: "Melancholy",
      speakerDistractors: ["The narrator", "A cloud", "A child"],
      moodDistractors: ["Joyful", "Mysterious", "Hopeful"]
    }
  ]
};
